import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "@redux-saga/core";
import { composeWithDevTools } from "redux-devtools-extension";

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 

import rootSaga from "../sagas/index";

import rootReducer from "../reducers/index";
import {constiBenchReducer} from "../../redux/reducers/constiBenchReducers" // only desired reducer persistance
const sagaMiddleware = createSagaMiddleware();

// const enhancers = [composeWithDevTools(), applyMiddleware(sagaMiddleware)];

// const store = createStore(rootReducer,  applyMiddleware(sagaMiddleware));

const persistConfig = {
    key: 'root',
    storage,
  };

const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = createStore(persistedReducer);
const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store);
export default store;
